import { render, staticRenderFns } from "./PsychometricsDetail.vue?vue&type=template&id=d514c534&"
import script from "./PsychometricsDetail.vue?vue&type=script&lang=js&"
export * from "./PsychometricsDetail.vue?vue&type=script&lang=js&"
import style0 from "./PsychometricsDetail.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports